import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PagesForm from '../../../components/forms/PagesForm';
import { usePagesApi } from '../../../hooks/usePagesApi';
import { useNavigate, useParams } from 'react-router-dom';
import { PagesDTO } from '../../../services/apiClient';

const PagesEdit: React.FC = () => {
  const { getById, edit } = usePagesApi();
  const [entityData, setEntityData] = useState<PagesDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Pages', href: '/admin/pages' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Page data:', error);
      }
    };

    fetchEntityData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (data: PagesDTO) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/pages');
    } catch (error) {
      console.error('Error updating Page:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/pages"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Content.Page.Edit"
    >
      {entityData ? (
        <PagesForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/pages')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default PagesEdit;
